export default "__VITE_ASSET__DRP0YB$7__"